import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  DecisionUploadFormLabel,
  DecisionUploadFormError,
} from '../components/DecisionUploadFormComponents';

type Props = {
  errors: Array<string>;
};

function getErrorMessage(errors: Array<string>) {
  if (
    errors.some(item =>
      ['UNDEFINED_DAY', 'UNDEFINED_MONTH', 'UNDEFINED_YEAR'].includes(item),
    )
  ) {
    return <FormattedMessage id="date/DecisionUploadDateField.tsx/2" />;
  }
  if (errors.includes('INVALID_DATE')) {
    return <FormattedMessage id="date/DecisionUploadDateField.tsx/3" />;
  }
  if (errors.includes('WRONG_YEAR')) {
    return <FormattedMessage id="date/DecisionUploadDateField.tsx/4" />;
  }
  if (errors.includes('FUTURE_DATE')) {
    return <FormattedMessage id="date/DecisionUploadDateField.tsx/5" />;
  }
  return null;
}

export const DecisionUploadDateField: FC<Props> = ({ errors, children }) => (
  <>
    <DecisionUploadFormLabel htmlFor="upload-date">
      <FormattedMessage id="date/DecisionUploadDateField.tsx/1" />
    </DecisionUploadFormLabel>
    <div className="input-group" id="upload-date">
      {children}
    </div>
    {errors.length > 0 && (
      <DecisionUploadFormError>
        {getErrorMessage(errors)}
      </DecisionUploadFormError>
    )}
  </>
);
